import { render, staticRenderFns } from "./yyznxq.vue?vue&type=template&id=40775bd2&scoped=true&"
import script from "./yyznxq.vue?vue&type=script&lang=js&"
export * from "./yyznxq.vue?vue&type=script&lang=js&"
import style0 from "./yyznxq.vue?vue&type=style&index=0&id=40775bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40775bd2",
  null
  
)

component.options.__file = "yyznxq.vue"
export default component.exports